import {Hemisphere} from '../../types';
import {DUE_PRESETS, dueLabel, presetDate} from '../../lib/todos';

// "When" for a to-do: the presets as one-tap choice chips, and a date picker for anything else.
// A chip shows as chosen when its date is the one set.
type Props = {value: string | null; onChange: (dueLocal: string | null) => void; today: string; hemisphere: Hemisphere | null | undefined};

export default function WhenChips({value, onChange, today, hemisphere}: Props) {
    const presets = DUE_PRESETS.map(p => ({...p, date: presetDate(p.preset, today, hemisphere)}));
    const matched = presets.some(p => p.date === value);
    return (
        <fieldset className="m-0 flex flex-col gap-2 border-0 p-0">
            <legend className="band-label mb-1 p-0 text-ink-2">When</legend>
            <div className="flex flex-wrap gap-2">
                {presets.map(p => (
                    <button key={p.preset} type="button" className="chip" aria-pressed={p.date === value} onClick={() => onChange(p.date)}>
                        {p.label}
                    </button>
                ))}
                <label className={`chip relative cursor-pointer ${value !== null && !matched ? 'border-shoot bg-shoot-soft font-bold text-shoot-text' : ''}`}>
                    {value !== null && !matched ? dueLabel(value, today) : 'Pick a date'}
                    <input
                        type="date"
                        aria-label="Pick a date"
                        className="absolute inset-0 cursor-pointer opacity-0"
                        min={today}
                        value={value ?? ''}
                        onChange={e => onChange(e.target.value || null)}
                    />
                </label>
            </div>
        </fieldset>
    );
}
